import { RAID_SIZE } from "@/shared/lib/raid";
import { startOfWeekOn, todayIso } from "@/shared/utils/date";

// Bounds on visible day columns. MAX_WINDOW_DAYS doubles as the fetched window, so resizing re-slices client-side; only navigating refetches.
export const MIN_WINDOW_DAYS = 7;
export const MAX_WINDOW_DAYS = 42;
// DAY_COLUMN_PX must equal the w-10 (40px) day cell in GridCell/DayHeaderCell.
// NAME_COLUMN_PX is an estimate for the content-sized name column, not an enforced width.
export const DAY_COLUMN_PX = 40;
export const NAME_COLUMN_PX = 160;
export const WINDOW_STEP = 7; // prev/next steps a week
// Monday (0=Sun..6=Sat); windows start here so navigation moves in whole weeks.
export const WEEK_START_DOW = 1;

// Most recent Monday on/before today. Shared by loader, initial state, and reset so startIso (and query keys) match.
export function defaultWindowStart(): string {
  return startOfWeekOn(todayIso(), WEEK_START_DOW);
}

// Below this present count a day reads under-strength (red); at/above, raid-ready (green).
export const PRESENT_THRESHOLD = RAID_SIZE;
